import Superagent from 'superagent'
import Storage from './storage.service'

const { HOST_API } = _CONSTANTS_

export default {
    getTracings,
    createTracing,
    deleteTracing
}

function getTracings(shipmentId) {
    return new Promise((resolve, reject) => {

        Superagent
           .get(`${HOST_API}/tracings/${shipmentId}`)
           .set('access', Storage.getItem('access'))
           .end((err, res) => {
               resolve(res.body)
           })
    })
}

function createTracing(data) {
    return new Promise((resolve, reject) => {

        Superagent
           .post(`${HOST_API}/tracings`)
           .set('access', Storage.getItem('access'))
           .send(data)
           .end((err, res) => {
               resolve(res.body)
           })
    })
}

function deleteTracing(tracingId) {
    return new Promise((resolve, reject) => {

        Superagent
           .delete(`${HOST_API}/tracings/${tracingId}`)
           .set('access', Storage.getItem('access'))
           .end((err, res) => {
               resolve(res.body)
           })
    })
}